import HistoricalRepository from "./HistoricalReposiory";
import { DeviceReadingParams, DeviceReadingResponse } from "./Historical";

export default class HistoricalService {
  private readonly historicalRepository: HistoricalRepository =
    new HistoricalRepository();

  async postHistoricalFiles(file: any): Promise<boolean> {
    return await this.historicalRepository.postHistoricalFiles(file);
  }

  async getHistoricalFiles({
    name = null,
    status = null,
    page = 1,
    size = 10,
    loading = true,
  }: {
    name?: null | string;
    status?: null | string;
    page: number;
    size: number;
    loading?: boolean;
  }): Promise<any> {
    return await this.historicalRepository.getHistoricalFiles({
      name,
      status,
      page,
      size,
      loading,
    });
  }
  async deleteHistoricalFile(
    historicalFileId: string | number
  ): Promise<any[]> {
    return await this.historicalRepository.deleteHistoricalFile(
      historicalFileId
    );
  }

  async getReadingsFromDevice(params: DeviceReadingParams): Promise<DeviceReadingResponse | undefined> {
    return await this.historicalRepository.getReadingsFromDevice(params);
  }

  // Convenience method with individual parameters (backward compatibility)
  async getReadingsFromDeviceByParams(
    parameterId: string,
    source: string,
    dateFrom: string,
    dateTo: string,
    valueInterval: number = 5,
    typeInterval: string = "minutes"
  ): Promise<DeviceReadingResponse | undefined> {
    return await this.historicalRepository.getReadingsFromDevice({
      parameterId,
      source,
      dateFrom,
      dateTo,
      valueInterval,
      typeInterval
    });
  }
}
